import axios from 'axios';
import { API_URL } from '../config/api.config';
import { authAxios, getAuthInfo } from './axiosInstance';

export const inspectionService = {
  async getInspections() {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching inspections:', error);
      throw error;
    }
  },
  async getAllInspectionsByGarageId() {
    try {
      const { garageId } = getAuthInfo();

      console.log("User data garageId: ", garageId);
      const response = await authAxios.get(`/inspections/garage/${garageId}`);
      console.log("Filtered inspections: ", response.data.inspections);
      return response.data.inspections;
    } catch (error) {
      console.error('Error get inspection by garage id:', error);
      throw error;
    }
  },
  async updateInspectionStatus(id: string, status: string) {
    try {
      const { garageId } = getAuthInfo();

      const response = await authAxios.put(`/inspections/${id}/status`, { status, garageId });
      console.log("update inspection status, ", status, garageId)
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getGarageStatsInspections(garageId: string) {
    try {
      const response = await authAxios.get(`/inspections/garage/${garageId}/stats`);

      console.log("getGarageStatsInspections : ", response.data)
      return response.data;
    } catch (error) {
      console.error('Error get inspection by garage id:', error);
      throw error;
    }
  },
  async getInspectionById(inspectionId: String, withFilter = true) {
    try {
      const { garageId } = getAuthInfo();
      if (withFilter) {
        const response =  await authAxios.get(`/inspections/garage/${garageId}/${inspectionId}`);
        return response.data;
      }
      else {
        const response =  await authAxios.get(`/inspections/${inspectionId}`);
        return response.data;
      }

    } catch (error) {
      console.error('Error get inspection by id:', error);
      throw error;
    }
  },
  async viewInspectionDetails(inspectionId: string) {
    try {
      const { garageId } = getAuthInfo();

      const response = await authAxios.post(`/inspections/${inspectionId}/view`, { garageId });

      console.log("viewInspectionDetails response:", response.data);

      return {
        inspection: response.data.inspection
      };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        throw {
          insufficientCredits: true,
          message: error.response.data.message || "Crédits insuffisants pour consulter cette inspection",
          creditsType: error.response.data.creditsType
        };
      }

      console.error('Error viewing inspection details:', error);
      throw error;
    }
  },


  async getUnreadMessageByInspectionId(inspectionId: string, garageId: string) {
    try {
      const response = await authAxios.get(`chat/messages/unread/${inspectionId}?userId=${garageId}`);
      return response.data.count;
    } catch (error) {
      console.error('Error fetching credit balance:', error);
      throw error;
    }
  },
  async generateAIAnalysis(inspectionId: string) {
    try {
      const { garageId } = getAuthInfo();

      const response = await authAxios.post(`/inspections/${inspectionId}/ai-analysis`, { garageId });
      return response.data;
    } catch (error) {
      console.error('Error generating AI analysis:', error);
      throw error;
    }
  },
};